module.exports = __webpack_public_path__ + "static/animation-services-bag-e3b1327d2ca3d22866a35b7f0522cfdc.png";